import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let EntranceExitMarkItem = class EntranceExitMarkItem extends Vue {
    info;
    disabled;
    type;
    onMouseenter(iconInfo) {
        // const id = iconInfo.id;
        this.$emit('onMouseenter', { ...iconInfo, dataType: this.type });
    }
    onMouseleave(iconInfo) {
        // const id = iconInfo.id;
        this.$emit('onMouseleave', { ...iconInfo, dataType: this.type });
    }
    markIcon(iconInfo) {
        if (this.disabled)
            return false;
        // const id = iconInfo.id;
        this.$emit('markIcon', { ...iconInfo, dataType: this.type });
    }
};
__decorate([
    Prop()
], EntranceExitMarkItem.prototype, "info", void 0);
__decorate([
    Prop()
], EntranceExitMarkItem.prototype, "disabled", void 0);
__decorate([
    Prop()
], EntranceExitMarkItem.prototype, "type", void 0);
EntranceExitMarkItem = __decorate([
    Component({
        name: 'entranceExitMarkItem',
        components: {},
        i18n: {
            messages: {
                en: {
                    add: 'Add',
                },
                zh: {
                    add: '添加',
                },
            },
        },
    })
], EntranceExitMarkItem);
export default EntranceExitMarkItem;
